var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrcLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 728.46 259.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2,.cls-3{fill-rule:evenodd;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 74.31,
    y1: 26.8,
    x2: 74.31,
    y2: 138.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8dc63f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 49.44,
    y1: 140.87,
    x2: 49.44,
    y2: 20.38,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.19,171h82.75c20.37,0,36.41,5.6,46.59,15.79,8.15,8.15,12.22,18.07,12.22,30.3v.51c0,20.11-10.69,31.32-23.42,38.45,20.62,7.89,33.35,19.85,33.35,43.79v.51c0,32.59-26.48,48.88-66.7,48.88H260.19ZM362.8,223.72c0-11.72-9.16-18.34-25.72-18.34h-38.7v37.69h36.16c17.31,0,28.26-5.61,28.26-18.84Zm-19.1,51.94H298.38v39.21H345c17.31,0,27.75-6.11,27.75-19.35V295C372.73,283,363.82,275.66,343.7,275.66Z",
    transform: "translate(-56.14 -167.96)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444,171h81.48c22.66,0,40.23,6.37,51.95,18.08,9.93,9.93,15.27,23.93,15.27,40.74v.51c0,28.77-15.53,46.85-38.19,55.25L598,349.24H552.18l-38.19-57h-30.8v57H444Zm78.93,86.57c19.1,0,30.05-10.19,30.05-25.2v-.51c0-16.81-11.71-25.47-30.8-25.47h-39v51.18Z",
    transform: "translate(-56.14 -167.96)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M620.13,260.64v-.51c0-50.67,38.2-92.17,92.94-92.17,33.61,0,53.71,11.2,70.27,27.49l-25,28.78c-13.75-12.48-27.75-20.12-45.57-20.12-30,0-51.69,24.95-51.69,55.51v.51c0,30.55,21.13,56,51.69,56,20.36,0,32.85-8.16,46.85-20.89l25,25.21c-18.34,19.61-38.7,31.82-73.08,31.82C659.08,352.29,620.13,311.81,620.13,260.64Z",
    transform: "translate(-56.14 -167.96)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.49,421.57l3.92-4.66c3.55,3.07,7.16,4.82,11.72,4.82,4,0,6.56-1.91,6.56-4.66V417c0-2.65-1.47-4.09-8.36-5.67C266.43,409.38,262,407,262,400.21v-.11c0-6.35,5.29-10.76,12.66-10.76A20.55,20.55,0,0,1,288.1,394l-3.49,4.93c-3.34-2.49-6.68-3.82-10.07-3.82-3.82,0-6.05,2-6.05,4.4v.1c0,2.87,1.7,4.14,8.86,5.84,7.84,1.91,11.87,4.72,11.87,10.87v.1c0,6.94-5.46,11.07-13.26,11.07A22.81,22.81,0,0,1,260.49,421.57Z",
    transform: "translate(-56.14 -167.96)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.08,413.09V413c0-8,5.67-14.58,13.68-14.58,8.9,0,13.4,7,13.4,15,0,.58-.05,1.16-.1,1.81H343.5a7.8,7.8,0,0,0,8.05,7.09,10.17,10.17,0,0,0,7.58-3.33l3.76,3.33a14.11,14.11,0,0,1-11.44,5.25C343.33,427.61,337.08,421.73,337.08,413.09ZM357.8,411c-.42-4.13-2.86-7.37-7.09-7.37-3.93,0-6.68,3-7.27,7.37Z",
    transform: "translate(-56.14 -167.96)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M413.07,399h6.41v6.31c1.76-4.19,5-7.06,9.92-6.84v6.78H429c-5.62,0-9.54,3.66-9.54,11.09V427h-6.41Z",
    transform: "translate(-56.14 -167.96)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.76,399h6.9l7.52,20.56L496.75,399h6.74L492,427.19h-5.77Z",
    transform: "translate(-56.14 -167.96)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M551.5,388.61h6.89v6.09H551.5Zm.27,10.38h6.41v28h-6.41Z",
    transform: "translate(-56.14 -167.96)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M607.46,413.14V413A14.45,14.45,0,0,1,622,398.41a14.09,14.09,0,0,1,11.19,4.83l-4,4.28c-2-2.06-4-3.49-7.21-3.49-4.66,0-8.11,4-8.11,8.91v.1c0,5,3.45,8.95,8.38,8.95a9.77,9.77,0,0,0,7.25-3.44l3.88,3.81a14.68,14.68,0,0,1-25.93-9.22Z",
    transform: "translate(-56.14 -167.96)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M679.38,413.09V413c0-8,5.67-14.58,13.68-14.58,8.9,0,13.41,7,13.41,15,0,.58-.05,1.16-.11,1.81H685.8a7.81,7.81,0,0,0,8.06,7.09,10.15,10.15,0,0,0,7.57-3.33l3.77,3.33a14.15,14.15,0,0,1-11.45,5.25C685.63,427.61,679.38,421.73,679.38,413.09ZM700.11,411c-.43-4.13-2.86-7.37-7.11-7.37-3.91,0-6.67,3-7.25,7.37Z",
    transform: "translate(-56.14 -167.96)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M753.11,423.32,756,419a15.78,15.78,0,0,0,9.17,3.46c2.75,0,4.35-1.17,4.35-3v-.11c0-2.17-3-2.91-6.26-3.92-4.13-1.17-8.74-2.86-8.74-8.22V407c0-5.29,4.39-8.53,10-8.53a19.41,19.41,0,0,1,10.28,3.19l-2.54,4.55a16.28,16.28,0,0,0-7.9-2.65c-2.49,0-3.92,1.17-3.92,2.76v.1c0,2.07,3,2.92,6.31,4,4.07,1.27,8.69,3.13,8.69,8.16v.11c0,5.88-4.56,8.79-10.39,8.79A19.59,19.59,0,0,1,753.11,423.32Z",
    transform: "translate(-56.14 -167.96)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "148.62 92.32 98.87 162.75 0 21.87 98.87 21.87 148.62 92.32"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 162.75 98.87 162.75 49.44 92.32 0 162.75"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrcLogo);
export default __webpack_public_path__ + "static/media/brc-logo.9e62c4a2cdcac18fc20ff0cd3638bab5.svg";
export { ForwardRef as ReactComponent };